import { Camera } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";

const slots = [
  "Photo slot 01 — Finished fence",
  "Photo slot 02 — Zoom-in on the bracket",
];

export const PhotoSlots = () => (
  <section className="section" data-testid="photo-slots-section">
    <div className="wrap">
      <Reveal>
        <div className="eyebrow">
          <span className="eyebrow-num">—</span>
          <span>Product photos — to come</span>
        </div>
      </Reveal>
      <div className="photo-slots">
        {slots.map((s, i) => (
          <Reveal key={s} delay={i * 0.1}>
            <div className="photo-slot" data-testid={`photo-slot-${i + 1}`}>
              <Camera size={26} aria-hidden="true" />
              <span>{s}</span>
              <span style={{ opacity: 0.6 }}>Image pending</span>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
